import { render } from "./side-bar-haeder.vue?vue&type=template&id=2832a0a8"
import script from "./side-bar-haeder.vue?vue&type=script&lang=js"
export * from "./side-bar-haeder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__